import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import styles from "./SettingsScreen.module.scss";

import {
  selectEditSchoolPending,
  selectedSchool,
} from "../../store/slices/school/slice";

import Button from "../../components/Button/Button";
import Card from "../../components/Card/Card";
import Input from "../../components/Input/Input";
import CheckBox from "../../components/CheckBox/CheckBox";
import ImageLoader from "../../components/ImageLoader/ImageLoader";
import { editSchool, fetchSchool } from "../../store/slices/school/asyncThunks";
import { notifyError, notifyInfo } from "../../utils/notify";

const SettingsScreen = () => {
  const getSelectedSchool = useSelector(selectedSchool);
  const editSchoolPending = useSelector(selectEditSchoolPending);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchSchool({}));
  }, [dispatch]);

  useEffect(() => {
    if (getSelectedSchool) {
      setAddress(getSelectedSchool.address);
      setZipCode(getSelectedSchool.zipCode);
      setCity(getSelectedSchool.city);
      if (getSelectedSchool.phoneNumber) {
        setPhoneNumber(getSelectedSchool.phoneNumber);
      } else {
        setPhoneNumber("");
      }
      setSchoolName(getSelectedSchool.name);
      setStateName(getSelectedSchool.state);
      setAlertAdmins(getSelectedSchool.alertAdmins);
      setAlertMinutesBeforeStart(getSelectedSchool.alertMinutes);
    }
  }, [getSelectedSchool]);

  const [address, setAddress] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [city, setCity] = useState("");
  const [stateName, setStateName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [profilePhoto, setProfilePhoto] = useState(null);

  const [alertMinutesBeforeStart, setAlertMinutesBeforeStart] = useState(5);
  const [isAlertAdmins, setAlertAdmins] = useState(false);

  const saveSettings = () => {
    if (address === "") {
      notifyError("Address field is empty");
      return;
    } else if (zipCode === "") {
      notifyError("Zip Code field is empty");
      return;
    } else if (city === "") {
      notifyError("City field is empty");
      return;
    } else if (stateName === "") {
      notifyError("State field is empty");
      return;
    } else if (phoneNumber === "") {
      notifyError("Phone number field is empty");
      return;
    } else if (schoolName === "") {
      notifyError("School name field is empty");
      return;
    }

    dispatch(
      editSchool({
        address,
        city,
        zipCode,
        phoneNumber,
        state: stateName,
        name: schoolName,
        logoUrl: profilePhoto,
        alertAdmins: isAlertAdmins,
        alertMinutes: alertMinutesBeforeStart,
      })
    ).then((promise) => {
      if (promise.type.includes("fulfilled")) {
        notifyInfo("Successfully updated school details");
      } else {
        notifyError(promise.error.message);
      }
    });
  };

  const onChangeRangeInput = (event) => {
    setAlertMinutesBeforeStart(event.target.value);
  };
  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <h1 className={styles.headerTitle}>Settings</h1>
        <Button
          className={styles.headerButton}
          aria-label="Save"
          title="Save"
          disabled={editSchoolPending}
          loading={editSchoolPending}
          onClick={saveSettings}
        />
      </div>
      <div className={styles.firstColumnContainer}>
        <div className={styles.schoolLogoContainer}></div>

        <Card className={styles.card}>
          <div className={styles.schoolLogoContainer}>
            <ImageLoader
              user={{
                firstName: "S",
                lastName: "L",
                profilePhoto: getSelectedSchool?.logoUrl,
              }}
              textUploadImage={"Upload Photo"}
              setImageFile={setProfilePhoto}
              classNameContainer={styles.logoSpace}
              classNameLogo={styles.logoStyle}
              flexColumn={false}
            ></ImageLoader>
          </div>
        </Card>

        <Card className={styles.card}>
          <h2>School Details</h2>
          <Input
            placeholder="School Name"
            onChange={(event) => setSchoolName(event)}
            value={schoolName || ""}
          ></Input>
          <Input
            placeholder="Address"
            onChange={(event) => setAddress(event)}
            value={address || ""}
          ></Input>
          <Input
            placeholder="Zip Code"
            onChange={(event) => setZipCode(event)}
            value={zipCode || ""}
          ></Input>
          <Input
            placeholder="City"
            onChange={(event) => setCity(event)}
            value={city || ""}
          ></Input>
          <Input
            placeholder="State"
            onChange={(event) => setStateName(event)}
            value={stateName || ""}
          ></Input>
          <Input
            placeholder="Phone Number"
            onChange={(event) => setPhoneNumber(event)}
            value={phoneNumber || ""}
          ></Input>
        </Card>

        <Card className={styles.card}>
          <div className={styles.alertsContainer}>
            <h2 style={{ paddingBottom: "1rem" }}>Alerts</h2>

            <div className={styles.missingStudentsContainer}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span className={styles.sendNotificationText}>
                  Send notifications before period start:
                </span>
                <div className={styles.alertMinutesBeforeStart}>
                  {alertMinutesBeforeStart}min
                </div>
              </div>
            </div>
            <div style={{ paddingBottom: "2rem" }}>
              <input
                onChange={onChangeRangeInput}
                type="range"
                value={alertMinutesBeforeStart}
                min="0"
                max="60"
              />
            </div>
            <div
              className={styles.checkboxContainer}
              style={{ paddingBottom: "0rem" }}
            >
              <CheckBox
                checked={isAlertAdmins}
                onClick={() =>
                  setAlertAdmins((prevState) => {
                    return !prevState;
                  })
                }
                className={styles.checkbox}
              />
              <h3>Send notifications to admins</h3>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default SettingsScreen;
